import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const ITestService = ( createDecorator('testService'));
export { ITestService };
